import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "d-flex header-default" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "cursor-pointer"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M19.84 10.92V12.92H7.84L13.34 18.42L11.92 19.84L4 11.92L11.92 4L13.34 5.42L7.84 10.92H19.84Z",
      fill: "#70737C"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import ButtonDefault from "@/components/ButtonDefault.vue";
import { redirectToWantUrl } from "@/utils/redirects";

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})